import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface projectHeaderState {
    isJetlift: boolean;
    isComparison: boolean;
    isReports?: boolean;
}

export const initialState: projectHeaderState = {
    isJetlift: true,
    isComparison: false,
    isReports: false,
};

const projectHeaderSlice = createSlice({
    name: "projectHeader",
    initialState,
    reducers: {
        setIsJetlift: (state, action: PayloadAction<boolean>) => {
            state.isJetlift = action.payload;
        },
        setIsComparison: (state, action: PayloadAction<boolean>) => {
            state.isComparison = action.payload;
        },
        setIsReports: (state, action: PayloadAction<boolean>) => {
            state.isReports = action.payload;
        },
    },
});

export const { setIsJetlift, setIsComparison, setIsReports } = projectHeaderSlice.actions;

export default projectHeaderSlice.reducer;
